import { useQuery } from "@apollo/client/react";
import GET_FILE from "../queries/getFile";
import type { FileModel } from "../../models/FileModel";

type FileResponse = {
  file: FileModel;
};

export const useFile = (id: string, clientIdentifier?: string) => {
  const { data, error, loading, refetch } = useQuery<FileResponse>(GET_FILE, {
    variables: { id: id, clientIdentifier: clientIdentifier },
  });
  return { file: data?.file, error, loading, refetch };
};
